const Menu = [
  { path: "/dashboard", icon: "fa fa-home", title: "Dashboard" },
  {
    path: "/venta",
    icon: "fa fa-money-bill-alt",
    title: "Ventas",
    children: [
      { path: "/venta/registrar_comprobante", title: "Registrar comprobante" },
      { path: "/venta/comprobantes_emitidos", title: "Comprobantes emitidos" },
      { path: "/venta/notas_emitidas", title: "Notas de Credito y Debito" },
      { path: "/venta/registro_pagos", title: "Registro de pagos" },
      { path: "/venta/invalidaciones", title: "Registro de invalidaciones" },
    ],
  },

  {
    path: "/compras",
    icon: "fa fa-calculator",
    title: "Compras",
    children: [
      // { path: "/compras/registrar_comprobante", title: "Registrar comprobante" },
      { path: "/compras/comprobantes_proveedores", title: "Comprobantes" },
    ],
  },

  { path: "/terceros", icon: "fa fa-users", title: "Clientes/Proveedores" },
  { path: "/eventos_contingencia", icon: "fa fa-fire-extinguisher", title: "Evento de Contingencia" },

  // { path: "/usuarios", icon: "fa fa-user-check", title: "Usuarios" },
  // {
  //   path: "/parametros",
  //   icon: "fa fa-cog",
  //   title: "Parametros",
  //   children: [{ path: "/parametros/talonario", title: "Talonarios" }],
  // },
];

export default Menu;
